import { Component, computed, effect, inject, signal, untracked } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { NgxSkeletonLoaderComponent } from 'ngx-skeleton-loader';
import { StoreRequest } from '@bn/shared/state-store';
import { CardComponent } from '@bn/web-ui/card/card.component';
import { BotCategorizationGroup } from '../../openapi';
import { ShieldApiStore, ShieldBotCategorizationApiStore } from '../../stores';
import { AppShieldBotControlsGroupComponent } from './app-shield-bot-controls-group/app-shield-bot-controls-group.component';

@Component({
  selector: 'app-shield-bot-controls',
  templateUrl: './app-shield-bot-controls.component.html',
  styleUrl: './app-shield-bot-controls.component.scss',
  imports: [CardComponent, FaIconComponent, NgxSkeletonLoaderComponent, AppShieldBotControlsGroupComponent],
})
export class AppShieldBotControlsComponent {
  readonly #shieldStore = inject(ShieldApiStore);
  readonly #botStore = inject(ShieldBotCategorizationApiStore);

  protected readonly shield = this.#shieldStore.selectedEntity();
  protected readonly isLoading = this.#botStore.isLoading(StoreRequest.List);

  protected readonly search = signal('');

  protected readonly shieldZoneId = computed(() => this.shield()?.shieldZoneId ?? null);

  protected readonly filteredGroups = computed<BotCategorizationGroup[]>(() => {
    const term = this.search().trim().toLowerCase();
    const groups = this.#botStore.categories();

    if (!term) return groups;

    return groups
      .map((group) => ({ ...group, bots: (group.bots ?? []).filter((bot) => (bot.userAgentMatch ?? '').toLowerCase().includes(term)) }))
      .filter((group) => (group.bots?.length ?? 0) > 0);
  });

  protected readonly hasSearch = computed(() => this.search().trim().length > 0);
  protected readonly isEmpty = computed(() => !this.isLoading() && this.filteredGroups().length === 0);

  constructor() {
    effect(() => {
      const shieldZoneId = this.shieldZoneId();

      if (shieldZoneId) untracked(() => this.#botStore.getBotCategorizations({ shieldZoneId }));
    });
  }

  protected onSearch(value: string): void {
    this.search.set(value);
  }
}
